import React from 'react';
import { CheckIcon, PlusIcon, XIcon } from 'lucide-react';
import { comparisons, modulos, modulosExtra } from '../data/megapack';
import { SectionHeading } from './SectionHeading';
const problems = ['El grupo vuelve alterado del patio.', 'No escucha la consigna.', 'Aparece un berrinche.', 'Hay conflictos por juguetes.', 'Se desordena la transición.', 'La seño termina agotada de repetir lo mismo diez veces.'];
export function Sistema360Section() {
  return <section className="w-full bg-forest-50 px-5 py-16 sm:py-20" aria-labelledby="sistema-title" data-id="element-185" data-mp="u4xx9i9zx6u">
      <div className="mx-auto max-w-4xl" data-id="element-186" data-mp="3s0g5lohsjw75">
        <SectionHeading id="sistema-title" eyebrow="Versión completa" title={<>
              ¿Qué agrega el <span className="mark-gold" data-id="element-188" data-mp="5mobi6gyqsbn">MegaPack Seño Jardín 360</span>?
            </>} subtitle="La diferencia entre tener actividades y poder sostener una sala con más calma." data-id="element-187" data-mp="amapwj8j2em1" />

        <div className="mt-10 grid gap-5 sm:grid-cols-2" data-id="element-189" data-mp="fldvc4sf6muj">
          <div className="rounded-3xl border-2 border-forest-100 bg-white p-6 shadow-card" data-id="element-190" data-mp="fmyrtzyaofv1">
            <p className="text-[11px] font-extrabold uppercase tracking-[0.18em] text-forest-900/45" data-id="element-191" data-mp="2t0k3l3e6tlp8">
              El problema real
            </p>
            <ul className="mt-3 space-y-2" data-id="element-192" data-mp="31zxdfx684cah">
              {problems.map(problem => <li key={problem} className="flex items-start gap-2 text-[13px] text-forest-900/75" data-id="element-193" data-mp="321qnznjyjgnr">
                  <XIcon className="mt-0.5 h-4 w-4 flex-none text-blush-500" aria-hidden="true" data-id="element-194" data-mp="36we1krdfaqnk" />
                  {problem}
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl border-2 border-lime-200 bg-lime-100 p-6 shadow-card" data-id="element-195" data-mp="3fxvniqdihmk6">
            <p className="text-[11px] font-extrabold uppercase tracking-[0.18em] text-forest-700" data-id="element-196" data-mp="3kqou7jsjj4yw">
              Por eso la versión 360 incluye
            </p>
            <h3 className="mt-3 font-display text-xl font-extrabold text-forest-800" data-id="element-197" data-mp="3uouvbz6iw72p">
              Sistema Sala en Armonía
            </h3>
            <p className="mt-2 font-hand text-xl text-forest-700" data-id="element-198" data-mp="3ijmvhz6o41c">
              Convivencia, calma y conducción de grupo para Nivel Inicial
            </p>
          </div>
        </div>

        {/* Comparación */}
        <div className="mt-12 overflow-hidden rounded-3xl border-2 border-forest-100 shadow-card" data-id="element-199" data-mp="34y2yiaboywti">
          <div className="hidden grid-cols-3 bg-forest-800 text-cream sm:grid" data-id="element-200" data-mp="3jr6g2hpa9ak8">
            <p className="p-4 text-[11px] font-extrabold uppercase tracking-[0.16em]" data-id="element-201" data-mp="3ewsjibyvwxdz">
              Situación real
            </p>
            <p className="p-4 text-[11px] font-extrabold uppercase tracking-[0.16em] text-blush-100" data-id="element-202" data-mp="3srl1dh28ypnq">
              Sin el sistema
            </p>
            <p className="p-4 text-[11px] font-extrabold uppercase tracking-[0.16em] text-lime-200" data-id="element-203" data-mp="6hikjcqak8af">
              Con el sistema
            </p>
          </div>

          <div className="divide-y-2 divide-forest-100" data-id="element-204" data-mp="289wvfruf4chc">
            {comparisons.map(row => <div key={row.situation} className="grid gap-3 bg-white p-4 sm:grid-cols-3 sm:gap-0 sm:p-0" data-id="element-205" data-mp="28brknicq2qr8">
                <p className="font-display text-base font-extrabold text-forest-800 sm:p-4" data-id="element-206" data-mp="ist1wfoxnbjp">
                  {row.situation}
                </p>
                <div className="flex items-start gap-2 rounded-xl bg-blush-100/60 p-3 text-[13px] text-forest-900/70 sm:rounded-none sm:bg-transparent sm:p-4" data-id="element-207" data-mp="nqumj520bixa">
                  <XIcon className="mt-0.5 h-4 w-4 flex-none text-blush-600" aria-hidden="true" data-id="element-208" data-mp="e1t5rcnn0xi9" />
                  <span data-id="element-209" data-mp="2jp6bvis1dr">{row.without}</span>
                </div>
                <div className="flex items-start gap-2 rounded-xl bg-lime-100 p-3 text-[13px] font-semibold text-forest-800 sm:rounded-none sm:p-4" data-id="element-210" data-mp="108wl9v5qbz">
                  <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-lime-600" aria-hidden="true" data-id="element-211" data-mp="3ma1f2m8ptn83" />
                  <span data-id="element-212" data-mp="3r8321i99i6ou">{row.with}</span>
                </div>
              </div>)}
          </div>
        </div>

        {/* Módulos */}
        <div className="mt-12 rounded-3xl border-2 border-forest-100 bg-white p-6 shadow-card sm:p-8" data-id="element-213" data-mp="1kioc42qb5peo">
          <h3 className="font-display text-xl font-extrabold text-forest-800 sm:text-2xl" data-id="element-214" data-mp="1pgpyoxmy06uw">
            Sistema Sala en Armonía incluye:
          </h3>
          <ol className="mt-5 grid gap-2.5 sm:grid-cols-2" data-id="element-215" data-mp="3gkrshdwejj6z">
            {modulos.map((modulo, index) => <li key={modulo} className="flex items-start gap-3 rounded-2xl border-2 border-forest-100 bg-cream p-3.5" data-id="element-216" data-mp="3cjg0x2tywnw5" data-mpi={index}>
                <span className="flex h-6 w-6 flex-none items-center justify-center rounded-full bg-forest-800 font-display text-[11px] font-extrabold text-cream" data-id="element-217" data-mp="37lejsng3qynb">
                  {index + 1}
                </span>
                <span className="text-[13px] font-semibold text-forest-900/85" data-id="element-218" data-mp="2xu0cvultmwk5">{modulo}</span>
              </li>)}
          </ol>

          <p className="mt-8 text-[11px] font-extrabold uppercase tracking-[0.18em] text-lime-600" data-id="element-219" data-mp="2stmel4a0v0zb">
            Además
          </p>
          <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-220" data-mp="2jur3pew192po">
            {modulosExtra.map(extra => <li key={extra} className="flex items-start gap-2 text-[13px] text-forest-900/80" data-id="element-221" data-mp="2evxqlnknrdq1">
                <PlusIcon className="mt-0.5 h-4 w-4 flex-none text-lime-600" aria-hidden="true" data-id="element-222" data-mp="udvlhq70uz14" />
                {extra}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}